import { render, staticRenderFns } from "./QuestionAnswerCards.vue?vue&type=template&id=27aca43e&scoped=true"
import script from "./QuestionAnswerCards.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerCards.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswerCards.vue?vue&type=style&index=0&id=27aca43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aca43e",
  null
  
)

export default component.exports